const { connect } = require('react-redux');
const React = require('react');
const PropTypes = require('prop-types');
const { formatText, FormattedText } = require('core/i18n').i18n;
const parser = require('ua-parser-js');
const infoImage = require('assets/images/info-icon.svg');
const { LoadingSection } = require('commonsComponents/loadingSection');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

const { formatDate/*, milisecBetweenDates*/ } = require('utilities/dateHelper');
const { DateText } = require('components/dateText/dateText')

// const ONE_HOUR = 3600000;


class GridDevicesSessionRowContent extends React.Component {

    constructor(props) {
        super(props);
        this.renderSessions = this.renderSessions.bind(this)
    }

    // renderDuration(session) {
    //     if (session.active) {
    //         return formatText('manageDevices-sessionActiveSeparated')
    //     }
    //     return (
    //         <div>
    //             <DateText customClassName="sessions__row__prop--capitalize" text={session.fhStart} textEnd={session.fhEnd} format="betweenDates"/>
    //             {
    //                 milisecBetweenDates(session.fhStart, session.fhEnd) === ONE_HOUR &&
    //                     this.renderTooltip(formatText('manageDevices-sessionHourInfo'))
    //             }
    //         </div>
    //     )
    // }

    renderState(session) {
        return (session.active) ? formatText('manageDevices-sessionActiveSeparated') : formatText('manageDevices-sessionInactiveSeparated')
    }

    renderPlatform(device){
        return `${device.model ? device.model : ""} ${device.osVersion}`
    }

    renderVersion(device){
        return device.version ? (device.type !== 'MOBILE' ? parser(device.version).browser.name : device.version) : ""
    }

    renderTooltip(content){
        const target = <img className="sessions__row__prop__icon" src={infoImage}/>
        return (
            <OKTooltip
                target={target}
                content={content}
                offset={[0, -15]}
                placement="top"
            />
        )
    }

    renderSession(device, session, isLast){
        const renderAuxDiv = (label, text, col, rootingInfo) => {
            const content = (
                <div>
                    {formatText('manageDevices-sessionTooltipTextRooted')}
                    <a className="sessions__row__prop__tooltip__link" href="https://www.openbank.es/security">{formatText('manageDevices-knowMore')}</a>
                </div>
            )
            return (
                <div className={`sessions__row__prop ${col}`}>
                    <label className="sessions__row__prop__title">{label ? label : ""}</label>
                    <p className="sessions__row__prop__text">{text ? text : ""}</p>
                    {rootingInfo && this.renderTooltip(content)}
                </div>
            )
        }

        const renderRooted = () => {
            return renderAuxDiv(formatText('manageDevices-sessionPropLabelRooted'),
                                formatText('manageDevices-sessionPropTextRooted'),
                                "col-md-2",
                                true)
        }

        return (
            <div key={session.sid} className="sessions__div">
                <div key="first-row" className="sessions__row row">
                    {renderAuxDiv(formatText('manageDevices-sessionPropLabelDevice'), this.renderPlatform(device), "col-md-offset-1 col-md-5")}
                    {/* {renderAuxDiv(formatText('manageDevices-sessionPropLabelCountry'), session.country ? session.country : "-", "col-md-2")} */}
                    {renderAuxDiv(formatText('manageDevices-sessionPropLabelAccessDate'), formatDate(session.fhStart), "col-md-2")}
                    {/* {renderAuxDiv(formatText('manageDevices-sessionPropLabelAccessDuration'), this.renderDuration(session), "col-md-2")} */}
                    {renderAuxDiv(formatText('manageDevices-sessionPropLabelAccessState'), this.renderState(session), "col-md-2")}
                </div>
                <div key="second-row" className="sessions__row row">
                    {renderAuxDiv(formatText('manageDevices-sessionPropLabelVersion'), this.renderVersion(device), "col-md-offset-1 col-md-5")}
                    {/* {renderAuxDiv(formatText('manageDevices-sessionPropLabelLocation'), session.city ? session.city : "-", "col-md-2")} */}
                    {renderAuxDiv(formatText('manageDevices-sessionPropLabelAccessHour'), <DateText customClassName="sessions__row__prop--capitalize" text={session.fhStart} format="HH:mm"/>, "col-md-2")}
                    {device.rooted && renderRooted()}
                </div>
                {!isLast && <div className="col-md-offset-2 col-md-10 sessions__div__separation"></div>}
            </div>
        )
    }

    renderLoading(){
        return (
            <div className="col-md-offset-2 col-md-10 sessions__loading">
                <LoadingSection />
            </div>
        )
    }

    renderEmpty(){
        return (
            <div className="col-xs-12 sessions__no-sessions">
                <FormattedText value="manageDevices-noSessions"/>
            </div>
        )
    }

    renderSessions = (device, sessions) => {
        if (!sessions) return null
        if (!sessions.length) return this.renderEmpty()
        return sessions.map((s, i) => this.renderSession(device, s, i === sessions.length - 1))
    }

    render() {
        const {device, sessions, isFetching} = this.props
        if (isFetching)
            return this.renderLoading()

        return (
            <div className="sessions row">
                {this.renderSessions(device, sessions)}
            </div>
        );
    }
}

GridDevicesSessionRowContent.propTypes = {
    device: PropTypes.shape({
        sid: PropTypes.string.isRequired
    }),
    sessions: PropTypes.array,
    isFetching: PropTypes.bool
}

GridDevicesSessionRowContent.defaultProps = {
    devices: {sid: "00000000-0000-0000-0000-000000000000"},
    sessions: [],
    requestSessionsByDevice: () => [],
    removeSessionsByDevice: () => []
}

const mapStateToProps = (state, ownProps) => {
    const sessions = state.devices.get("sessions").get(ownProps.device.sid)

    return {
        sessions: sessions ? sessions : null,
        isFetching: state.devices.getIn(['isFetchingSession', ownProps.device.sid])
    }
}

module.exports.constructor = connect(mapStateToProps)(GridDevicesSessionRowContent)
module.exports.GridDevicesSessionRowContent = connect(mapStateToProps)(GridDevicesSessionRowContent)
